<template>
  <div class="badge">
    <div class="icon" :style="badge.customStyle" v-if="badge.type == 'svg'">
      <IconBase
        icon-name="badge"
        iconColor="#444"
        :viewBox="badge.viewBox"
        :scale="badge.scale"
        width="100%"
        height="100%"
        strokeWidth="0px"
        ><component v-bind:is="badge.badgeSVG"></component
      ></IconBase>
    </div>
    <div class="icon regular-icon" v-else-if="badge.type == 'regular'">
      <img v-if="!badge.customSize" class="png-badge" :src="badge.badgeImageURLBig" height="400px" width="400px" />
      <img v-else class="png-badge" :src="badge.badgeImageURLBig" height="385px" width="385px" />
    </div>
    <div class="title">{{ badge.badgeName }}</div>
  </div>
</template>


<script>
import IconBase from "../IconBase";

export default {
  name: "BadgeBig",
  props: ["badge", "badgeStyle"],
  components: {
    BadgeBug: () => import("./BadgeSVGs/BadgeBug"),
    BadgeCelebration: () => import("./BadgeSVGs/BadgeCelebration"),
    BadgeWelcome: () => import("./BadgeSVGs/BadgeWelcome"),
    BadgeWelcome2: () => import("./BadgeSVGs/BadgeWelcome2"),
    Badge100: () => import("./BadgeSVGs/Badge100"),
    BadgeBugMaster: () => import("./BadgeSVGs/BadgeBugMaster"),
    BadgeCommunityBuilder: () => import("./BadgeSVGs/BadgeCommunityBuilder"),
    IconBase,
    BadgeFounderMissedSession: () =>
      import("./BadgeSVGs/BadgeFounderMissedSession"),
    Badge100Alone: () => import("./BadgeSVGs/Badge100Alone"),
    Badge500: () => import("./BadgeSVGs/Badge500"),
    BadgeUnicorn: () => import("./BadgeSVGs/BadgeUnicorn"),
    BadgeLinkedIn: () => import("./BadgeSVGs/BadgeLinkedIn"),
    BadgeOnboarding: () => import("./BadgeSVGs/BadgeOnboarding"),
  },
};
</script>

<style scoped>
.badge {
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  align-items: center;
  padding: 10px 35px;
  border-radius: 4px;
  cursor: pointer;
  transition: 0.2s ease-in-out;
}

.badge:hover {
  transform: scale(1.05);
}

.badge .icon {
  width: 244px !important;
  height: 244px !important;
  border-radius: 360px;
  left: 10px;
  border: 6px solid #caf1ec;
  z-index: 999;
  background-color: #ffd60df7;
  background-color: #7dded16b;
  /* box-sizing: border-box; */
  -o-object-fit: cover;
  object-fit: contain;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding: 14px;
}

.badge .regular-icon {
  border-color: #e2e2e2;
  background-color: white;
}

.badge .title {
  font-size: 23px;
  font-weight: 600;
}
</style>
